import { render, staticRenderFns } from "./EventManagerPage.vue?vue&type=template&id=4e532362"
import script from "./EventManagerPage.vue?vue&type=script&lang=js"
export * from "./EventManagerPage.vue?vue&type=script&lang=js"
import style0 from "./EventManagerPage.vue?vue&type=style&index=0&id=4e532362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports